<template>
	<div class="" style="padding: 0;height: 100%;width: 90%;">
		<div class="" id="righthomeBottom" @mouseenter="clearDispatchTimer" @mouseleave="setDispatchTimer"
			style="height: 100%;width: 100%;"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				interVal: '',
				myChart: null,
				app: {
					currentIndex: -1,
				},
				dispatchTimer: null,
				dataLen: null
			}
		},
		mounted() {
			// this.requestData(500)
			this.init()
		},
		methods: {
			requestData(number, area, tulongNum, beforeMoney, afterMoney) {
				this.$request('center/newService1/farmLines?num=' + number + '&area=' + area + '&tulongNum=' + tulongNum +
					'&beforeMoney=' + beforeMoney + '&afterMoney=' + afterMoney).then(res => {
					if (this.myChart) {
						clearInterval(this.dispatchTimer)
						this.myChart.clear()
					}
					for (var i = 0; i < res.data.length; i++) {
						if (res.data[i].type == 1) {
							this.init(res.data[i].list);
						}
					}

				})
			},
			init(pageData, type) {
				let that = this
				that.myChart = echarts.init(document.getElementById('righthomeBottom'))

				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});

				let result = [{
						name: "2023年",
						ai: 0,
						ai2: 0
					},
					{
						name: "2024年",
						ai: 0,
						ai2: 0
					},
					{
						name: "2025年",
						ai: 1680,
						ai2: 1022
					}
				]

				let xData = result.map((item) => {
					return item.name
				});
				let keys = ['ai', 'ai2'],
					seriesData = [];
				let color = ['54, 127, 188', '255, 221, 0']

				seriesData.push({
					"name": '产量',
					"data": result.map((item) => {
						return item.ai
					}),
					"type": "line",
					"yAxisIndex": 0,
					"symbol": "none",
					"symbolSize": 7,
					"barWidth": 14,
					"splitNumber": 6,
					"smooth": false,
					"itemStyle": {
						"color": `rgba(${color[0]},1)`
					},
					"lineStyle": {
						"color": `rgba(${color[0]},1)`,
						"width": 1
					},
					"areaStyle": {
						"opacity": 1,
						"color": {
							"x": 0,
							"y": 0,
							"x2": 0,
							"y2": 1,
							"type": "linear",
							"global": false,
							"colorStops": [{
									"offset": 0,
									"color": `rgba(${color[0]},0.35)`
								},
								{
									"offset": 0.8,
									"color": "rgba(6, 8, 41,.1)"
								}
							]
						},
						"shadowColor": "rgba(0, 0, 0, 0.1)",
						"shadowBlur": 10
					}
				})

				seriesData.push({
					"name": '产值',
					"data": result.map((item) => {
						return item.ai2
					}),
					"type": "line",
					"yAxisIndex": 1,
					"symbol": "none",
					"symbolSize": 7,
					"barWidth": 14,
					"splitNumber": 6,
					"smooth": false,
					"itemStyle": {
						"color": `rgba(${color[1]},1)`
					},
					"lineStyle": {
						"color": `rgba(${color[1]},1)`,
						"width": 1
					},
					"areaStyle": {
						"opacity": 1,
						"color": {
							"x": 0,
							"y": 0,
							"x2": 0,
							"y2": 1,
							"type": "linear",
							"global": false,
							"colorStops": [{
									"offset": 0,
									"color": `rgba(${color[1]},0.35)`
								},
								{
									"offset": 0.8,
									"color": "rgba(6, 8, 41,.1)"
								}
							]
						},
						"shadowColor": "rgba(0, 0, 0, 0.1)",
						"shadowBlur": 10
					}
				})

				// keys.forEach((key, index) => {
				//     seriesData.push({
				//         "name": key == 'ai' ? '产量' : '产值',
				//         "data": result.map((item) => { return item[key] }),
				//         "type": "line",
				//         "yAxisIndex": 0,
				//         "symbol": "none",
				//         "symbolSize": 7,
				//         "barWidth": 14,
				//         "splitNumber": 6,
				//         "smooth": false,
				//         "itemStyle":
				//         {
				//             "color": `rgba(${color[index]},1)`
				//         },
				//         "lineStyle":
				//         {
				//             "color": `rgba(${color[index]},1)`,
				//             "width": 1
				//         },
				//         "areaStyle":
				//         {
				//             "opacity": 1,
				//             "color":
				//             {
				//                 "x": 0,
				//                 "y": 0,
				//                 "x2": 0,
				//                 "y2": 1,
				//                 "type": "linear",
				//                 "global": false,
				//                 "colorStops": [
				//                     {
				//                         "offset": 0,
				//                         "color": `rgba(${color[index]},0.35)`
				//                     },
				//                     {
				//                         "offset": 0.8,
				//                         "color": "rgba(6, 8, 41,.1)"
				//                     }]
				//             },
				//             "shadowColor": "rgba(0, 0, 0, 0.1)",
				//             "shadowBlur": 10
				//         }
				//     })
				//     seriesData.push({
				//         "name": key == 'ai' ? '产量' : '产值',
				//         "data": result.map((item) => { return item[key] }),
				//         "type": "line",
				//         "yAxisIndex": 1,
				//         "symbol": "none",
				//         "symbolSize": 7,
				//         "barWidth": 14,
				//         "splitNumber": 6,
				//         "smooth": false,
				//         "itemStyle":
				//         {
				//             "color": `rgba(${color[index]},1)`
				//         },
				//         "lineStyle":
				//         {
				//             "color": `rgba(${color[index]},1)`,
				//             "width": 1
				//         },
				//         "areaStyle":
				//         {
				//             "opacity": 1,
				//             "color":
				//             {
				//                 "x": 0,
				//                 "y": 0,
				//                 "x2": 0,
				//                 "y2": 1,
				//                 "type": "linear",
				//                 "global": false,
				//                 "colorStops": [
				//                     {
				//                         "offset": 0,
				//                         "color": `rgba(${color[index]},0.35)`
				//                     },
				//                     {
				//                         "offset": 0.8,
				//                         "color": "rgba(6, 8, 41,.1)"
				//                     }]
				//             },
				//             "shadowColor": "rgba(0, 0, 0, 0.1)",
				//             "shadowBlur": 10
				//         }
				//     })
				//     // seriesData.push({
				//     //     "name": key == 'ai' ? '产量' : '产值',
				//     //     "data": [{
				//     //         "coords": result.map((item) => { return [item.name, item[key]] }),
				//     //     }],
				//     //     "type": "lines",
				//     //     "coordinateSystem": "cartesian2d",
				//     //     "zlevel": 1,
				//     //     "polyline": true,
				//     //     "smooth": true,
				//     //     "symbol": "circle",
				//     //     "effect":
				//     //     {
				//     //         "show": false,
				//     //         "trailLength": 0.4,
				//     //         "symbol": "circle",
				//     //         "period": 8,
				//     //         "symbolSize": 8
				//     //     },
				//     //     "lineStyle":
				//     //     {
				//     //         "normal":
				//     //         {
				//     //             "color": `rgba(${color[index]},1)`,
				//     //             "width": 0,
				//     //             "opacity": 0,
				//     //             "curveness": 0
				//     //         }
				//     //     }
				//     // })
				// })

				var option = {
					"tooltip": {
						backgroundColor: '#001127',
						"trigger": "axis",
						"axisPointer": {
							"type": "line"
						},
						"padding": [8, 15],
						// "borderColor": "rgba(3, 11, 44, 0.5)",
						"textStyle": {
							"color": "rgba(255, 255, 255, 1)"
						},
						formatter: "{b}<br>{a}：{c} 吨<br>{a1}：{c1} 万元",
						formatter: (params, ticket, callback) => {
							const item = params[1];
							console.log(params);
							let da = ''
							for (let i = 0; i < params.length; i++) {
								if (params[i].seriesName == '产量') {
									da += params[i].seriesName + ':' + (params[i].value > 0 ? params[i].value :
										'-') + '吨 <br/>'
								} else if (params[i].seriesName == '产值') {
									da += params[i].seriesName + ':' + (params[i].value > 0 ? params[i].value :
										'-') + '万元 <br/>'
								}
							}
							return item.name + " <br/> " + da;
						},
					},
					"grid": {
						"show": true,
						"top": 50,
						"left": 20,
						"right": 30,
						"bottom": 36,
						"containLabel": true,
						"borderWidth": 0,
						"backgroundColor": "rgba(12, 45, 81, .3)"
					},
					"legend": {

						"show": true,
						"top": 10,
						"right": 130,
						"textStyle": {
							"padding": [0, 0, 0, 4],
							"fontSize": 15,
							"color": "#AEC6DF"
						}
					},

					"xAxis": {
						"type": "category",
						"boundaryGap": false,
						"data": xData,
						"axisPointer": {
							"handle": {
								"show": false
							}
						},
						"axisLine": {
							"show": false,
							"lineStyle": {
								"color": "#AEC6DF"
							}
						},
						"axisTick": {
							"show": false
						}
					},
					"yAxis": [{
						"show": true,
						"nameGap": 0,
						"min": 1500,
						"type": "value",
						"minInterval": 1,
						"splitNumber": 4,
						"splitLine": {
							"show": false
						},
						"axisTick": {
							"show": false
						},
						"minorSplitLine": {
							"show": false
						},
						"axisLine": {
							"show": false
						},
						"nameTextStyle": {
							"fontSize": 14,
							"padding": [0, 0, 0, -15],
							"align": "left",
							"color": "#AEC6DF;"
						},
						"axisLabel": {
							"color": "#AEC6DF"
						}
					}, {
						"show": true,
						"nameGap": 0,
						"min": 380,
						"type": "value",
						"minInterval": 1,
						"splitNumber": 4,
						"splitLine": {
							"show": false
						},
						"axisTick": {
							"show": false
						},
						"minorSplitLine": {
							"show": false
						},
						"axisLine": {
							"show": false
						},
						"nameTextStyle": {
							"fontSize": 14,
							"padding": [0, 0, 0, -15],
							"align": "left",
							"color": "#AEC6DF;"
						},
						"axisLabel": {
							"color": "#AEC6DF"
						}
					}],
					"series": seriesData
				}



				that.dataLen = option.series[0].data.length
				that.dispatchActions()

				that.myChart.setOption(option);
				this.interVal = setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 240000)
				// 20000
			},
			dispatchActions() {
				let that = this
				that.dispatchTimer = setInterval(function() {
					// 取消之前高亮的图形
					that.myChart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: that.app.currentIndex
					});
					that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
					// 高亮当前图形
					that.myChart.dispatchAction({
						type: 'highlight',
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
					// 显示 tooltip
					that.myChart.dispatchAction({
						type: 'showTip',
						seriesIndex: 0,
						dataIndex: that.app.currentIndex
					});
				}, 3000);
			},
			clearDispatchTimer() {
				clearInterval(this.dispatchTimer)
			},
			setDispatchTimer() {
				this.dispatchActions()
			},
		},
		destroyed() {
			clearInterval(this.interVal)
		},

	}
</script>

<style>
	.a {
		/* color: #fff; */
	}
</style>